module.exports = __webpack_public_path__ + "img/35b26a4.png";